export const modalRef = {
    current: null,
};
